"use client"

import { CookingPot } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CookingPotIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CookingPotIcon = component(Icon)({ as: CookingPot })
